/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Input.Gamepad
 */

module.exports = {

    Axis: require('./Axis'),
    Button: require('./Button'),
    Gamepad: require('./Gamepad'),
    GamepadManager: require('./GamepadManager'),
    
    Configs: require('./configs/')
};



//////////////////
// WEBPACK FOOTER
// ./input/gamepad/index.js
// module id = 780
// module chunks = 0